module.exports = __webpack_public_path__ + "img/email.a3c77776.jpg";